import { MotionFrame } from "../utilities/framer";
import InViewPort from "../utilities/in-viewport";

export const MobileUseCase = ({caption, message}) => {
     return (
        <MotionFrame>
            <div className="stack glassy-effect">
                <div className="service-cap">{caption}</div>
                <div className="process-descr">{message}</div>
            </div>
        </MotionFrame>
     );
}

export const SecurityData = ({caption, message, stat}) => {
     return (
        <InViewPort>
            <div className="stack glassy-effect">
                <div className="service-cap">{caption}</div>
                <div className="process-descr">{message}</div>
                <div className="sec-stats">{stat}</div>
            </div>
        </InViewPort>
     );
}